import i18n from 'i18next';
import { IBetslipCalculationField } from 'newelements/_Betslip/hooks/generateFieldsMapping/types';
import { generateSimpleId } from 'newelements/_Betslip/hooks/generateFieldsMapping/utils';

export class BetslipCalculationField implements IBetslipCalculationField {
  id: IBetslipCalculationField['id'];

  label: IBetslipCalculationField['label'];
  value: IBetslipCalculationField['value'];
  loading?: IBetslipCalculationField['loading'];
  attributes: IBetslipCalculationField['attributes'];

  constructor(
    label: IBetslipCalculationField['label'],
    value: IBetslipCalculationField['value'],
    loading?: IBetslipCalculationField['loading']
  );
  constructor(
    label: IBetslipCalculationField['label'],
    value: IBetslipCalculationField['value'],
    attributes?: IBetslipCalculationField['attributes']
  );
  constructor(
    label: IBetslipCalculationField['label'],
    value: IBetslipCalculationField['value'],
    attributes: IBetslipCalculationField['attributes'],
    loading?: IBetslipCalculationField['loading']
  );
  constructor(
    label: IBetslipCalculationField['label'],
    value: IBetslipCalculationField['value'],
    attributesOrLoading:
      | IBetslipCalculationField['attributes']
      | IBetslipCalculationField['loading'],
    _loading?: IBetslipCalculationField['loading']
  ) {
    this.label = i18n.t(label);
    this.value = value;
    this.id = generateSimpleId();
    const loading =
      typeof attributesOrLoading === 'boolean'
        ? attributesOrLoading
        : null ?? _loading;

    const attributes =
      typeof attributesOrLoading === 'boolean' ? {} : attributesOrLoading;

    this.attributes = attributes;
    this.loading = loading;
  }
}
